module.exports = "/images/vendor/flag-icon-css/flags/1x1/lb.svg?56f32195732ab1ad22f1f6a4473b3ace";